import { SvgIconTypeMap } from '@material-ui/core';
import { OverridableComponent } from '@material-ui/core/OverridableComponent';
import Dashboard from '@material-ui/icons/Dashboard';
import Inbox from '@material-ui/icons/Inbox';
import Group from '@material-ui/icons/Group';
import UserIcon from '@material-ui/icons/Person';
import { Assignment as ProjectIcon } from '@material-ui/icons';

// eslint-disable-next-line
export type NavigationType = NavigationTypeSingle | NavigationTypeGroup;

type NavigationTypeSingle = {
    id: string;
    path: string;
    label: string;
    icon: OverridableComponent<SvgIconTypeMap>;
    type: 'single';
    roles?: string[];
};

type NavigationTypeGroup = {
    id: string;
    label: string;
    icon: OverridableComponent<SvgIconTypeMap>;
    type: 'group';
    roles?: string[];
    children: NavigationType[];
};

export const Navigations: NavigationType[] = [
    {
        id: 'home',
        path: '/',
        label: 'ホーム',
        type: 'single',
        icon: Dashboard,
    },
    {
        id: 'projects',
        path: '/projects',
        label: 'プロジェクト',
        type: 'single',
        icon: ProjectIcon,
    },
    {
        id: 'admin-accounts',
        path: '/admin-accounts',
        label: '管理者',
        type: 'single',
        icon: UserIcon,
    }
];
